import Vue from 'vue';
import BotUI from 'botui';
import MoveTo from 'moveto';
import '../node_modules/botui/build/botui.min.css';
import '../node_modules/botui/build/botui-theme-default.css';


if (document.getElementById('pageNotFoundBot')) {
  const botui = BotUI('pageNotFoundBot', {
    vue: Vue,
  });

  const notFound = () => {
    botui.message.add({
      content: 'https://giphy.com/embed/9J7tdYltWyXIY',
      type: 'embed',
      loading: true,
      delay: 100,
    }).then(() => {
      botui.message.add({
        delay: 1000,
        content: 'You seem to have lost your way!',
      }).then(() => {
        botui.action.button({
          action: [
            {
              text: 'Go Back!',
              value: true,
            },
          ],
        }).then(() => {
          window.open('http://animeshmanglik.name');
          window.focus();
        });
      });
    });
  };

  window.onload = () => {
    notFound();
  };
}

if (document.getElementById('my-botui-app')) {
  const botui = BotUI('my-botui-app', {
    vue: Vue,
  });

  const moveTo = new MoveTo();

  const social = () => {
    botui.message.add({
      delay: 1000,
      content: 'Connect with me.',
    }).then(() => {
      botui.action.button({
        action: [
          {
            icon: 'linkedin',
            text: 'linkedin',
            value: true,
          },
        ],
      }).then(() => {
        window.open('https://www.linkedin.com/in/animeshmanglik', '_blank');
        window.focus();
      });
    });
  };

  const portfolio = () => {
    botui.message.add({
      delay: 1000,
      content: 'Wanna see my projects?',
    }).then(() => {
      botui.action.button({
        action: [
          {
            text: 'Yes',
            value: true,
          },
          {
            text: 'No',
            value: false,
          },
        ],
      }).then((project) => {
        if (project.value) {
          const target = document.getElementsByClassName('projects')[0];
          moveTo.move(target);
        }
        botui.message.add({
          delay: 1000,
          content: 'How about work experience?',
        }).then(() => {
          botui.action.button({
            action: [
              {
                text: 'Yes',
                value: true,
              },
              {
                text: 'No',
                value: false,
              },
            ],
          }).then((experience) => {
            if (experience.value) {
              const target = document.getElementsByClassName('experience')[0];
              moveTo.move(target);
            }
          }).then(() => {
            social();
          });
        });
      });
    });
  };

  const initial = () => {
      // First my image
    botui.message.add({
      content: 'https://animeshmanglik.name/static/img/image/image.html',
      type: 'embed',
      delay: 1000,
      loading: true,
    }).then(() => {
      botui.message.add({
        delay: 1000,
        content: 'Welcome to TL; DR version of my website.',
      }).then(() => {
        botui.message.add({
          delay: 1000,
          loading: true,
          content: 'Hows your day going?',
        }).then(() => {
          botui.action.button({
            action: [
              {
                text: 'Great',
                value: true,
              },
              {
                text: 'Meh!',
                value: false,
              },
            ],
          }).then((day) => {
            if (day.value) {
              botui.message.add({
                content: 'https://giphy.com/embed/1MTLxzwvOnvmE',
                type: 'embed',
                loading: true,
                delay: 100,
              });
            } else {
              botui.message.add({
                content: 'https://giphy.com/embed/BmMU3LOfNMMeI',
                type: 'embed',
                loading: true,
                delay: 100,
              });
            }
          }).then(() => {
            portfolio();
          });
        });
      });
    });
  };

  window.onload = () => {
    initial();
  };
}




// WEBPACK FOOTER //
// ./src/botMessage.js